<table
  class="ds-table ds-table-fixed"
  *ngIf="items && items.length; else noItemsAddedBlock"
>
  <thead>
    <tr>
      <ng-container
        *ngIf="headerTemplate; else useDefaultHeader"
        [ngTemplateOutlet]="headerTemplate"
        [ngTemplateOutletContext]="{ $implicit: columns }"
      >
      </ng-container>

      <ng-template #useDefaultHeader>
        <th
          *ngFor="let col of columns"
          [class.ds-table-col-30]="col.size == '30%'"
          [class.ds-table-col-20]="col.size == '20%'"
        >
          <app-detail-display [key]="col.key" [value]=""> </app-detail-display>
        </th>
        <!-- options column header is <td>, because <th> without text inside it is considered as accessibility error -->
        <td class="ds-table-col-20" *ngIf="isShowOptionsColumn"></td>
      </ng-template>
    </tr>
  </thead>

  <tbody>
    <ng-container *ngFor="let item of items; let index = index">
      <ng-container
        [ngTemplateOutlet]="repeatedSection"
        [ngTemplateOutletContext]="{ $implicit: { item, index } }"
      ></ng-container>
    </ng-container>

    <tr *ngIf="enablePagination">
      <pagination-controls
        [id]="paginationId"
        previousLabel="{{ 'PaginationPreviousLabel' | translate }}"
        nextLabel="{{ 'PaginationNextLabel' | translate }}"
        (pageChange)="currentPage = $event"
        [autoHide]="true"
        [responsive]="true"
        [maxSize]="3"
      >
      </pagination-controls>
    </tr>
  </tbody>
</table>

<ng-template #noItemsAddedBlock>
  <app-list-no-items></app-list-no-items>
</ng-template>

<ng-template #defaultDetailsTemplate let-item>
  <div class="row">
    <div
      *ngFor="let detail of details"
      dsCol
      [colOptions]="detail.responsiveSize"
    >
      <app-detail-display
        [key]="detail.key"
        [value]="formatValue(item[detail.property], detail)"
      ></app-detail-display>
    </div>
  </div>
</ng-template>

<ng-template #defaultRowTemplate let-row>
  <td
    *ngFor="let col of columns"
    [innerText]="formatValue(row.item[col.property], col)"
  ></td>
</ng-template>

<ng-template #customOptions let-row>
  <ng-container *ngFor="let option of options.customOptions; let index = index">
    <a
      *ngIf="option.behavior.clickHandler"
      [class]="option.styleClass"
      (click)="option.behavior.clickHandler($event, row)"
      (keydown.enter)="option.behavior.clickHandler($event, row, index)"
      tabindex="0"
    >
      <i [class]="option.icon.styleClass"></i>
    </a>
    <a
      *ngIf="option.behavior.router"
      [class]="option.styleClass"
      [routerLink]="option.behavior.router.link.resolver(row, index)"
      [queryParams]="option.behavior.router.queryParams.resolver(row, index)"
      tabindex="0"
      target="_blank"
    >
      <i [class]="option.icon.styleClass"></i>
    </a>
  </ng-container>
</ng-template>

<ng-template #repeatedSection let-row>
  <tr [class.ds-table-item-head-open]="isCollapsed[row.index] == false">
    <ng-container
      *ngIf="rowContentTemplate; else useDefaultRow"
      [ngTemplateOutlet]="rowContentTemplate"
      [ngTemplateOutletContext]="{ $implicit: row.item }"
    >
    </ng-container>

    <ng-template #useDefaultRow>
      <ng-container
        [ngTemplateOutlet]="defaultRowTemplate"
        [ngTemplateOutletContext]="{
          $implicit: { item: row.item, index: row.index }
        }"
      >
      </ng-container>
    </ng-template>

    <td class="ds-table-col-20" *ngIf="isShowOptionsColumn">
      <div class="ds-table-options">
        <ng-container>
          <a
            role="button"
            class="ds-btn-icon"
            *ngIf="enableEditing || options?.allowEditing"
            (click)="emitEdit($event, row.item)"
            (keydown.enter)="emitEdit($event, row.item)"
            [attr.aria-label]="'trEdit' | translate"
            tabindex="0"
          >
            <i class="fi-register fi-large"></i>
          </a>
          <a
            role="button"
            class="ds-btn-icon"
            *ngIf="enableEditing || options?.allowDeleting"
            (click)="emitDelete($event, row.item)"
            (keydown.enter)="emitDelete($event, row.item)"
            [attr.aria-label]="'trDelete' | translate"
            tabindex="0"
          >
            <i class="fi-close-thick"></i>
          </a>
        </ng-container>
        <a
          role="button"
          *ngIf="showCollapseDetailsButton"
          class="ds-btn-icon ds-btn-bg-bright"
          (click)="isCollapsed[row.index] = !isCollapsed[row.index]"
          [attr.aria-label]="'trExpand' | translate"
          [attr.aria-expanded]="!isCollapsed[row.index]"
          [attr.aria-controls]="'details-record-' + row.index"
          tabindex="0"
        >
          <i class="fi-arrow-thin-down"></i>
        </a>

        <ng-container
          *ngIf="options?.customOptions?.length > 0"
          [ngTemplateOutlet]="customOptions"
          [ngTemplateOutletContext]="{
            $implicit: { item: row.item, index: row.index }
          }"
        >
        </ng-container>
      </div>
    </td>
  </tr>

  <tr
    [id]="'details-record-' + row.index"
    *ngIf="(details && details.length) || detailsTemplate"
    [ngbCollapse]="isCollapsed[row.index] ?? (isCollapsed[row.index] = true)"
  >
    <ng-container
      *ngIf="detailsTemplate; else useDefault"
      [ngTemplateOutlet]="detailsTemplate"
      [ngTemplateOutletContext]="{ $implicit: row.item }"
    >
    </ng-container>

    <ng-template #useDefault>
      <td [attr.colspan]="detailsColSpan">
        <ng-container
          [ngTemplateOutlet]="defaultDetailsTemplate"
          [ngTemplateOutletContext]="{ $implicit: row.item }"
        >
        </ng-container>
      </td>
    </ng-template>
  </tr>
</ng-template>
